import { createFileRoute } from '../../utils/route-factory';

function Phones() {
  return <h1>Welcome to Phones</h1>;
}

export const Route = createFileRoute({
  path: '/sync-app/',
  component: Phones,
  type: 'auth',
  locationRequired: true,
});
